

let page = promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'black' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        home: true,
        event: true,
        sns: true,
        theme: 'black' //'black', 'white'
    }
});

$(document).on('click', '.btn-login', function(){
    promokit.login();
});
var video1 = promokit.video({
    el: '#player1',
    url: 'https://vod.plaync.com/lineage2/promo/whyburn.mp4',
    poster: window.promokitStore.staticPath+'/promo/lineage2/event/2020/201007_collection/img/whyburn/bg-default.jpg',
    controls: true
});



var layer1 = promokit.layer({
    el: '#layer-1',
    buttons: '.btn-layer1',
    render: true
});

var layer2 = promokit.layer({
    el: '#layer-2',
    buttons: '.btn-layer2',
    render: true
});

var pageMain = (function () {

    var init, select, tab;

    init = function(){
        select();
        tab();
    };

    tab = function () {


        $(document).on('click','.con-tab li', function (e) {
            e.preventDefault();
            var $tablist = $('.con-tab li');
            var $tabcons = $(".tab-con");

            if($(this).hasClass('disabled')) return;
            if ($(this).hasClass('active')) return;
            var target = $(this).index();
            resetTab($tablist, $tabcons);
            $tablist.eq(target).addClass('active');
            $tabcons.eq(target).show();
        });
    }

    function resetTab($tablist, $tabcons) {
        $tablist.removeClass('active');
        $tabcons.find('li').removeClass('active');
        $tabcons.hide();
    }


    select = function(){
        $(document).on('click', '[data-ui="custom-select"] .opener', function(e){

            var check = $(this).closest('.prevent').hasClass('prevent');
            if(!check) {
                $(this).toggleClass('active');
            }
        });

        $(document).on('click', '[data-ui="custom-select"] li', function(e){
            $(this).parent().prev().html($(this).html()).removeClass('active');
            $(this).parent().next().val($(this).attr('data-value'));
        });

        $(document).on('click', function(e){
            if(!($(e.target).is('[data-ui="custom-select"] .opener') || $(e.target).is('[data-ui="custom-select"] li'))){
                if(!($(e.target).is('[data-ui="custom-select"] .opener strong'))){
                    $('[data-ui="custom-select"] .opener').removeClass('active');
                }
            }
        });
    };

    return {
        init: function () {
            init();
        },
        resetTab:function(){
            var $div =$('.tab').closest('div');
            $div.removeClass();
            $div.addClass('tab01');
        }
    }
})();


$(document).ready(function () {
    pageMain.init();

});




// WEBPACK FOOTER //
// ./src/js/whyburn.js